import { Button, Link } from '@heroui/react'
import { getCurrentUserRoleInfo } from '#shared/lib/auth'
import { SuccessIllustration } from '#shared/ui/illustrations'
import styles from './payment-success.module.scss'

export default function PaymentSuccess() {
  const roleInfo = getCurrentUserRoleInfo()

  return (
    <div className={styles.root}>
      <SuccessIllustration className={styles.illustration} />

      <div className={styles.text}>Оплата прошла успешно, вернитесь в приложение</div>

      {roleInfo.isGiven && (
        <Button size="lg" color="primary" as={Link} href="/">
          На главную
        </Button>
      )}
    </div>
  )
}
